export default __webpack_public_path__ + "static/media/1841.9781edc9.png";